(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  
  function getCookie(name) {
    
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  function setCookie(name, value, days) {

    options = {
      path: '/',
    };

    if (days) {

      date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      
      options.expires = date.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      
      updatedCookie += "; " + optionKey;
      
      let optionValue = options[optionKey];
      
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  function deleteCookie(name) {
    setCookie(name, "", {
      'max-age': -1
    });
  }

  jQuery(function() {
    initNewsletterPopup();
  });

  function initNewsletterPopup() {
    
    var popup = jQuery('#newsletter_popup');
    var openedClass = 'opened';
    var bodyOpenedClass = 'newsletter-popup-opened';
    var control = jQuery('#newsletter-popup_control');
    var closeBtn = popup.find('.close');
    var body = jQuery('body');

    closeBtn.on('click', function(e) {
    
      e.preventDefault();

      hidePopup();
  
    });

    if (getCookie('kw_subscriber_popup') === null) {
      
      setTimeout(function() {
  
        if (popup.length) {
          
          showPopup();
          
          jQuery('.signup__close').on('click', function(){
            hidePopup();
          });

          jQuery(document).on('click',function (e) {
    
            if(popup.hasClass(openedClass)) {
              if (!jQuery(e.target).closest(popup).length) {
                hidePopup();
              }
            }
          });
        }
      }, popup.data('delay'));
    } 

    function showPopup() {
      
      setCookie('kw_subscriber_popup', '1', 30);

      popup.addClass(openedClass);
      body.addClass(bodyOpenedClass);  
    }

    function hidePopup() {
      popup.removeClass(openedClass);
      body.removeClass(bodyOpenedClass);
    }

    jQuery('#emailSignup').submit(function(event) {
    
      event.preventDefault();
    
      jQuery.ajax({
        url: 'https://kentwool.ax.technologyone.net/api/customer',
        type: 'POST',
        async: true,
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify({
          email: jQuery('#mce-EMAIL').val()
        }),
        success: function () {
          jQuery('#mce-EMAIL').val('');
          jQuery('#emailSignup').hide();
          jQuery('#emailSignupMsg').show();

          setCookie('kw_subscriber_popup', '1',  365);
        },
        error: function (response) {
          console.log(response);
        }
      });
    });

  }

  } catch(e) { console.error(e); }
})();
})();
